import {injectable} from "inversify";
import chance from "@/modules/base/services/chance";
import {PositionAreaEnum} from "@/modules/base/enums";
import {Coach} from "@/modules/training/entity";
import {AbstractStaffMemberFactory} from "@/modules/staff/services/factories/AbstractStaffMemberFactory";
import {StaffMember} from "@/modules/staff/entity";

@injectable()
export class CoachFactory extends AbstractStaffMemberFactory {
  protected make(): StaffMember {
    const couch = new Coach();

    if (chance.bool({likelihood: 80})) {
      couch.positionArea = chance.randomEnum(PositionAreaEnum);
    }

    return couch;
  }
}
